import _ from 'lodash';

import notificationService from '../notifications/notificationService';
import { SineHeader } from '../shared/types';

function getInformationForGeeks(response) {
  const headers = _.result(response, 'headers', {});
  return `Helpful information for Sine support:
        Status Code: ${response.status},
        Status Text: ${response.statusText},
        Request ID: ${headers[SineHeader.X_SINE_RQUID]},
        API Version: ${headers[SineHeader.X_SINE_VERSION]}`;
}

export function notificationResponseError(error) {
  if (error?.code === 'ERR_NETWORK') {
    notificationService.clearNotifications();
    notificationService.addNotification({
      heading: 'Network error',
      message: 'Check your network connection or contact your network administrator',
      variant: 'danger',
    });
    return;
  }

  const response = error.response;

  switch (response.status) {
    case -1:
      if (
        _.get(response, 'config.timeout._value') !== 'CANCELLED_REQUEST' &&
        !_.includes(_.get(response, 'config.url'), window.env.REACT_APP_SINE_WORKFLOWS_API_URI)
      ) {
        notificationService.addNotification({
          message: `We're having trouble connecting to our servers. Please check your internet connection and try again.`,
          variant: 'danger',
        });
      }
      break;

    case 400:
    case 401:
    case 403:
    case 404:
    case 406:
    case 409:
    case 410:
    case 424:
    case 498:
      // Do nothing, let the service/controller handle them
      break;

    case 413:
      notificationService.addNotification({
        message: `Wow, the information that you just tried to send must have been too big as our server rejected it. Please check that you have not accidentally pasted or typed something very large and then try again. If you are still having problems then please contact our support team. ${getInformationForGeeks(
          response,
        )}`,
        variant: 'danger',
      });
      break;

    case 429:
      notificationService.addNotification({
        message: 'Sorry, you have tried that too many times. Please wait a moment before trying again.',
        variant: 'danger',
      });
      break;

    case 500:
      notificationService.addNotification({
        message: `We're unable to process your request, our technology team has been notified. Please try again later or contact support. ${getInformationForGeeks(
          response,
        )}`,
        variant: 'danger',
      });
      break;

    case 504:
      notificationService.addNotification({
        heading: 'Gateway Timeout',
        message: 'The server timed out, please try again.',
        variant: 'danger',
      });
      break;

    default:
      notificationService.addNotification({
        message: `Something unexpected happened. Please try again later or contact support. ${getInformationForGeeks(
          response,
        )}`,
        variant: 'danger',
      });
  }
}
